import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'
import { store } from './store'
import router from '@/router'
import firebase from "firebase/compat/app"
import "firebase/compat/auth"

import {config} from '@/helpers/firebaseConfig'
firebase.initializeApp(config)

import VCalendar from "v-calendar"

Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
})

import VueMeta from 'vue-meta'
Vue.use(VueMeta,{
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
});

Vue.config.productionTip = false;
new Vue({
  vuetify,
  router,
  store,
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        // this.$router.push('/profile').catch(()=>{});
        store.dispatch('autoSignIn', user)
      } 
     });
    },
  
  render: h => h(App)
}).$mount('#app')
